<button type="button" class="visibility-button" (click)="toggleMyVisibility()">
  @if (isVisible) {
    <app-svg-icon [icon]="'assets/images/icon-visibility-on.svg'" [blank]="true" />
  } @else {
    <app-svg-icon [icon]="'assets/images/icon-visibility-off.svg'" [blank]="true" />
  }
</button>
